import axios from 'axios';
import Auth from '../helpers/auth';
import qs from 'qs';



class Api {

    endpoint = '';
    baseURL = process.env.REACT_APP_ACCOUNTS_API;
    redirectOn401 = true;

    getAxios() {
        const instance = axios.create({
            baseURL: this.baseURL,
            headers: {'Authorization': 'Bearer ' + Auth.getToken()},
            paramsSerializer: function(params) {
                return qs.stringify(params)
            },
        });

        instance.interceptors.response.use(null, this.errorInterceptor.bind(this));
        return instance;
    }

    errorInterceptor(error) {
        if (error.response) {
            const status = error.response.status;

            switch(status) {
                case 401:
                    Auth.signout();

                    if (this.redirectOn401) {
                        Auth.redirectToAccounts();
                    }

                    console.error('Authorization failed');
                    break;

                case 403:
                    window.location = '//accounts.polisuite.com.br/forbidden.html';
                    break;

                default:
                    break;
            }
        }

        return error;
    }

    getCancelSource() {
        return axios.CancelToken.source();
    }

    all(params) {
        return this.getAxios().get(`${this.endpoint}`, {params});
    }

    get(id, params) {
        return this.getAxios().get(`${this.endpoint}/${id}`, {params});
    }

    create(data) {
        return this.getAxios().post(`${this.endpoint}`, data);
    }

    update(id, data) {
        return this.getAxios().put(`${this.endpoint}/${id}`, data);
    }

    delete(id) {
        return this.getAxios().delete(`${this.endpoint}/${id}`);
    }

}

export default Api;




// WEBPACK FOOTER //
// ./src/psuite-js/apis/api.js